// 银行表格校验规则
const bankTableEditRules = {
  bankName: [{ required: true, message: window.vm.$t('cooperation.placeholder.bankName') }],
  bankCode: [{ required: true, message: window.vm.$t('cooperation.placeholder.bankCode') }],
  associatedLineNumber: [
    { required: true, message: window.vm.$t('cooperation.placeholder.associatedLineNumber') },
  ],
  accountBankBranch: [
    { required: true, message: window.vm.$t('cooperation.placeholder.accountBankBranch') },
  ],
  bankAccount: [{ required: true, message: window.vm.$t('cooperation.placeholder.bankAccount') }],
};
// 联系人表格校验规则
const linkTableEditRules = {
  contactPersonName: [
    { required: true, message: window.vm.$t('cooperation.placeholder.contactPersonName') },
  ],
  mobilePhone: [{ required: true, message: window.vm.$t('cooperation.placeholder.mobilePhone') }],
  telephone: [{ required: false, message: window.vm.$t('cooperation.placeholder.telephone') }],
  faxNo: [{ required: false, message: window.vm.$t('cooperation.placeholder.faxNo') }],
  email: [{ required: false, message: window.vm.$t('cooperation.placeholder.email') }],
  address: [{ required: false, message: window.vm.$t('cooperation.placeholder.address') }],
};
// 供应链主体客户校验规则
const supplyCustomerRules = {
  partnerZhName: [
    { required: true, message: window.vm.$t('cooperation.placeholder.partnerZhName') },
  ],
};
// 供应链主体服务商校验规则
const supplyServiceRules = {
  partnerZhName: [
    { required: true, message: window.vm.$t('cooperation.placeholder.partnerZhName') },
  ],
};

export { bankTableEditRules, linkTableEditRules, supplyCustomerRules, supplyServiceRules };
